import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  ArrowRight,
  BatteryCharging,
  Cable,
  FileText,
  HardDrive,
  ShieldAlert,
  Video,
  type LucideIcon,
} from "lucide-react";

/**
 * Gli strumenti, in faccia.
 *
 * Davide (26/08): «gli strumenti sono nella sidebar, in un tasto in basso:
 * a livello di visibilità non si notano nemmeno». I calcolatori sono uno dei
 * motivi per cui l'app vale piu' di una chat: una fila di scorciatoie sta
 * nella schermata d'apertura, sotto le comunicazioni. Le voci sono le quattro
 * piu' usate; il resto sta dietro «Tutti».
 *
 * LA DICO VIENE PRIMA, QUI E NELLA PAGINA STRUMENTI (Davide, 29/08, dal
 * telefono: i due elenchi mostravano ordini diversi). Sostituisce l'ordine
 * "dei lavori" di Umberto del 27/08 - pre-valutazione prima perche' si fa
 * prima dell'impianto - perche' due liste che non concordano disorientano
 * piu' di quanto aiuti la cronologia di cantiere. Chi cambia quest'ordine
 * cambi anche TOOLS in src/pages/Strumenti.tsx: devono dire la stessa cosa.
 *
 * Le prime due hanno un vestito diverso (Davide, 26/08: devono essere
 * "chiaramente in risalto"): sono atti che si firmano e si consegnano, gli
 * altri sono conti che si rifanno.
 */
const SCORCIATOIE: { to: string; label: string; Icon: LucideIcon; evidenza?: boolean }[] = [
  { to: "/conformita", label: "Dichiarazione di conformità", Icon: FileText, evidenza: true },
  { to: "/strumenti/rischio", label: "Pre-valutazione del rischio", Icon: ShieldAlert, evidenza: true },
  { to: "/strumenti/gdpr", label: "Cartello videosorveglianza", Icon: Video },
  { to: "/strumenti/alimentazione", label: "Alimentazione", Icon: BatteryCharging },
  { to: "/strumenti/cavo", label: "Cavo BUS", Icon: Cable },
  { to: "/strumenti/video", label: "Spazio NVR", Icon: HardDrive },
];

export function StrumentiScorciatoie() {
  return (
    <div className="w-full">
      <p className="mb-2 text-center text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
        Documenti e strumenti
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {SCORCIATOIE.map(({ to, label, Icon, evidenza }) => (
          <Link
            key={to}
            to={to}
            className={cn(
              "inline-flex min-h-11 items-center gap-2 rounded-full border transition-all hover:-translate-y-px",
              evidenza
                ? "w-full justify-center border-primary/50 bg-primary/[0.12] px-5 py-2.5 text-sm font-semibold text-foreground shadow-glow hover:border-primary hover:bg-primary/[0.18]"
                : "border-border/60 bg-surface/70 px-4 py-2 text-[13px] font-medium text-foreground hover:border-primary/60 hover:bg-surface",
            )}
          >
            <Icon className={cn("text-primary", evidenza ? "h-5 w-5" : "h-4 w-4")} />
            {label}
          </Link>
        ))}
        <Link
          to="/strumenti"
          className="inline-flex min-h-11 items-center gap-1.5 rounded-full border border-primary/40 bg-primary/10 px-4 py-2 text-[13px] font-semibold text-primary transition-all hover:-translate-y-px hover:bg-primary/15"
        >
          Tutti
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
